module.exports = __webpack_public_path__ + "img/boxing-live-stream.9433b9a3.png";